import React from 'react'
import _ from 'lodash'
import immutable from 'immutable'

export class LunaMapBox extends React.Component {
    constructor(props) {
        super(props)

        this._map = null

        // defaults
        // this._coords 	= null
        // this._zoom 		= 20
        // this._label 	= ''

        // if(this._item){
        // 	this._coords = {"lat" : this._item.getIn(['location','lat']), "lon" : this._item.getIn(['location','lon'])}
        // 	this._zoom = this._item.get('type') === 'destination' ? 9 : 20
        // 	this._label = this._item.get('name')
        // }

        this._item = this.props.item ? this.props.item : immutable.fromJS({})

        this.state = {
            item: null,
            pins: this.props.pins ? this.props.pins : null,
            coords: null,
            zoom: 20,
            label: '',
            valid: true,
            bounds: this._item.getIn(['opencage', 'bounds']) ? JSON.parse(this._item.getIn(['opencage', 'bounds'])) : {}
        }

        _.bindAll(this,
            'createMap',
            'updateMap'
        )
    }

    componentWillMount() {
        if (this._item) {
            this.setState({
                item: this._item,
                pins: this.props.pins ? this.props.pins : null,
                coords: {'lat': this._item.getIn(['location', 'lat']), 'lon': this._item.getIn(['location', 'lon'])},
                zoom: this._item.get('type') === 'destination' ? 9 : 20,
                label: this._item.get('name')
            })
        }
    }

    componentDidMount() {
        this.createMap()
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.item && this.state.item.size > 0) {
            if (this.state.item.get('name') !== nextProps.item.get('name') || this.state.pins !== nextProps.pins) {
                this.setState({
                    item: nextProps.item,
                    pins: nextProps.pins ? nextProps.pins : null,
                    coords: {
                        'lat': nextProps.item.getIn(['location', 'lat']),
                        'lon': nextProps.item.getIn(['location', 'lon'])
                    },
                    zoom: nextProps.item.get('type') === 'destination' ? 9 : 20,
                    label: nextProps.item.get('name')
                })
            }
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.item && this.state.item.size > 0) {
            if (this.state.item.get('name') !== prevState.item.get('name') || this.state.pins !== prevState.pins) {
                console.log('clear map')
                if (document.getElementById('map')) {
                    this._map.eachLayer(function (layer) {
                        this._map.removeLayer(layer)
                    }, this)
                }
                L.mapbox.styleLayer('mapbox://styles/lunamoons/cj1cetnqe004o2sllxy1aujo3').addTo(this._map)

                this.updateMap()
            }
        }
    }

    createMap() {
        if (this.state.item) {
            if (this.state.pins || (document.getElementById('map') && typeof this.state.coords.lat !== 'undefined' && this.state.coords.lat && typeof this.state.coords.lon !== 'undefined' && this.state.coords.lon)) {
                // load, scale, and center map
                document.getElementById('map').style.height = (document.getElementById('map').offsetWidth * 9 / 16 * .618) + 'px'
                L.mapbox.accessToken = 'pk.eyJ1IjoibHVuYW1vb25zIiwiYSI6ImNpZW5xZ2tkZTBocTRzMm0ydnF2NmJ6dDMifQ.gwbe_LcbHXQA-ckwZvLnYw'
                // Create map, set style
                this._map = L.mapbox.map('map', 'mapbox.light')
                L.mapbox.styleLayer('mapbox://styles/lunamoons/cj1cetnqe004o2sllxy1aujo3').addTo(this._map)
                this.updateMap()
            } else {
                if (this.state.valid) {
                    this.setState({valid: false})
                }
            }
        } else {
            // console.log("you don't know where you are")
            if (this.state.valid) {
                this.setState({valid: false})
            }
        }
    }

    updateMap() {
        if (this._map && this.state.item.size > 0) {
            // clear it off
            // this._map.eachLayer(function (layer) {
            //     this._map.removeLayer(layer);
            // }, this)
            if (document.getElementById('map') && typeof this.state.coords.lat !== 'undefined' && this.state.coords.lat && typeof this.state.coords.lon !== 'undefined' && this.state.coords.lon) {
                // console.log('this one')
                this._map.setView([this.state.coords.lat, this.state.coords.lon], this.state.zoom)
                if (this.state.item.get('type') !== 'destination') {
                    let featureLayer = L.mapbox.featureLayer({
                        type: 'Feature',
                        geometry: {
                            type: 'Point',
                            coordinates: [this.state.coords.lon, this.state.coords.lat]
                        },
                        properties: {
                            // 'title': this.props.mapItem.name,     			        //this doesn't seem to do anything
                            'marker-size': 'medium',
                            'marker-color': '#DF6E54'
                        }
                    }).addTo(this._map)
                }
                this._map.scrollWheelZoom.disable()
                window.addEventListener('resize', () => {
                    this.setMapHeight()
                })

                if (typeof this.state.bounds.south !== 'undefined') {
                    this._map.fitBounds([
                        [this.state.bounds.south, this.state.bounds.west],
                        [this.state.bounds.north, this.state.bounds.east]
                    ])
                    // zoom in one level after setting the bounds
                    this._map.setZoom(this._map.getZoom() + 1)
                }
            } else {
                console.log('WARNING: This destination does not have any opencage location data. It will not be possible to do nearby searches.')
            }
        } else if (this._map && this.state.pins) {
            if (document.getElementById('map')) {
                let pinFeatures = {
                    'type': 'FeatureCollection',
                    'features': []
                }
                _.each(this.state.pins.toJS(), function (pin) {
                    let dLink = '#leg.' + pin.leg_id + '/uistatus.destination~overview'
                    // console.log("the link is "+dLink)
                    pinFeatures.features.push({
                        type: 'Feature',
                        geometry: {
                            type: 'Point',
                            coordinates: [pin.longitude, pin.latitude]
                        },
                        properties: {
                            'title': pin.destination,
                            'marker-size': 'medium',
                            'marker-color': '#DF6E54',
                            url: dLink
                        }
                    })
                })
                // add the pins to the map
                let featureLayer = L.mapbox.featureLayer(pinFeatures).addTo(this._map)
                // fit the map to the bounds
                this._map.fitBounds(featureLayer.getBounds())
                // set the title to show on hover
                featureLayer.on('mouseover', function (e) {
                    e.layer.openPopup()
                })
                featureLayer.on('mouseout', function (e) {
                    e.layer.closePopup()
                })
                featureLayer.on('click', function (e) {
                    window.location.hash = e.layer.feature.properties.url
                })

                this._map.scrollWheelZoom.disable()
                window.addEventListener('resize', () => {
                    this.setMapHeight()
                })
            } else {
                console.log('WARNING: There is no map object to locate the pins on')
            }
        } else {
            console.log('WARNING: No data received for map')
        }
    }

    setMapHeight() {
        let mapElement = document.getElementById('map')
        if (mapElement) {
            mapElement.style.height = (mapElement.offsetWidth * 9 / 16 * .618) + 'px'
        }
    }


    render() {
        let mapTitle = ''
        if (this.state.item && this.state.item.size > 0) {
            let mapTitle = this.state.item ? 'of ' + this.state.item.get('name') : ''
        }
        if (this.state.valid) {
            return (
                <div className="map-container">
                    <h3>Map { mapTitle }</h3>
                    <div id="map" className="light"/>
                </div>
            )
        } else {
            return null
        }
    }
}